import { useCallback } from "react";

export const useUpdateHeights = (
    enabled: boolean,
    navRef: React.MutableRefObject<HTMLDivElement>,
    heightWatchingSelector: string,
    heightUpdateSelector: string
): (() => void) => {
    return useCallback(() => {
        if (!enabled) return;

        if (navRef.current) {
            const heightWatchingElements = document.querySelectorAll(`${heightWatchingSelector}`);
            const heightUpdateElements = document.querySelectorAll(`${heightUpdateSelector}`);

            const height = Math.max(
                ...Array.from(heightWatchingElements).map(d => {
                    const style = window.getComputedStyle(d);

                    return (d.clientHeight ?? 0) + (parseFloat(style.marginBottom) ?? 0);
                })
            );
            Array.from(heightUpdateElements).forEach(d => {
                (d as HTMLElement).style.minHeight = `${height}px`;
            });
        }
    }, [enabled, navRef, heightUpdateSelector, heightWatchingSelector]);
};
